module.exports = __webpack_public_path__ + "static/media/ขาล.a90865db.png";